import { fromSqlDateTime } from "helpers/Date";
import React, { useContext } from "react";
import { ContainerContext } from "context/Container";

function StaticDateField(props) {
    const { state } = useContext(ContainerContext);

    if (state.loading || state.performingStateChange || !state.container) {
        return (
            <div>
                <span className="-mb-1 block text-xs font-bold uppercase text-gray-600">
                    {props.label}
                </span>
                <span className="animate-pulse rounded bg-gray-300 text-sm text-gray-300">
                    00/00/0000 00:00:00
                </span>
            </div>
        );
    }

    return (
        <div>
            <span className="-mb-1 block text-xs font-bold uppercase text-gray-600">
                {props.label}
            </span>
            <span className="text-sm">
                {state.container[props.field]
                    ? fromSqlDateTime(state.container[props.field]).toFormat(
                          "ff"
                      )
                    : props.defaultValue}
            </span>
        </div>
    );
}

export default StaticDateField;
